import { PollStatus } from 'constants/index'
import { colors } from 'utils/colors'
import { sortBy } from 'lodash'
import moment from 'moment'

export const getPollStatusText = (status) => {
  if (status === PollStatus.CREATED) {
    return { status: 'Not Started', bgColor: colors.red, color: colors.white }
  } else if (status === PollStatus.STARTED || status === PollStatus.RESUMED) {
    return { status: 'In Progress', bgColor: colors.blue, color: colors.white }
  } else if (status === PollStatus.PAUSED) {
    return { status: 'Paused', bgColor: colors.yellow, color: colors.white }
  } else return { status: 'Concluded', bgColor: colors.green, color: colors.black }
}

export const getPollType = (poll) => {
  if ((poll.sessionId && poll.talkId) || poll.talkId) return 'Poster/Talk Poll'
  else if (poll.sessionId && !poll.talkId) return 'Sub Event Poll'
  else if (poll?.eventId && !poll.talkId && !poll.sessionId) return 'Event Poll'
  else return 'N/A'
}

export const getUpdatedPollsAlongAssociatedData = (
  polls,
  events,
  sessions,
  talks,
  speakers = [],
  speakerName = null
) => {
  const updatedPolls = polls?.map((poll) => {
    const speaker = speakers?.find((speaker) => speaker?.id === poll.speakerId)
    let associatedTitle = 'N/A'
    let startDate = ''
    let endDate = ''
    let isAssociated = false

    if (poll?.talkId) {
      const talk = talks?.find((talk) => talk?.id === poll?.talkId)
      startDate = talk?.startDate
      endDate = talk?.endDate
      associatedTitle = talk?.title
      isAssociated = true
    } else if (poll?.sessionId) {
      const session = sessions?.find((session) => session?.id === poll?.sessionId)
      startDate = session?.startDate
      endDate = session?.endDate
      associatedTitle = session?.title
      isAssociated = true
    } else if (poll?.eventId) {
      const event = events?.find((event) => event?.id === poll?.eventId)
      startDate = event?.startDate
      endDate = event?.endDate
      associatedTitle = event?.title
      isAssociated = true
    }

    return {
      ...poll,
      speaker: speakers?.length ? speaker?.fullName : speakerName,
      associatedTitle: associatedTitle,
      startDate: startDate,
      endDate: endDate,
      isAssociated: isAssociated
    }
  })

  const usedPolls = updatedPolls.filter((poll) => poll.alreadyUsed && poll?.startDate)
  const partiallyUsedPolls = updatedPolls.filter((poll) => poll.alreadyUsed && !poll?.startDate)
  const freePolls = updatedPolls.filter((poll) => !poll.alreadyUsed)

  const sortedUsedPolls = sortBy(usedPolls, (obj) => obj?.startDate)
  const sortedPartiallyUsed = sortBy(partiallyUsedPolls, (obj) => moment(obj?.startDate))
  const sortedFreePolls = sortBy(freePolls, (obj) => obj?.title)
  return [...sortedUsedPolls, ...sortedPartiallyUsed, ...sortedFreePolls]
}
